import { defineMessages } from 'react-intl';

const messages = defineMessages({
  moreInfo: {
    id: 'moreInfo',
    defaultMessage: 'More info'
  }
});

export default messages;
